const es = {
    "profession": "Profesion",
    "duration": "Duracion",
    "price": "Precio",
    "sub-profession": "Servicio",
    "min": "min",
    "next": "Siguente",
    "personal_details": "Datos personales",
    "business_hours": "Horario comercial",
    "reset_to_default": "Restablecer por defecto",
    "back": "Volver",
    "fullName": "Nombre completo",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "description": "Acerca de mí",
    "signed_up_success": "¡Registro exitoso!",
    "go_to_diary": "Ir a la agenda",
    "login_with_facebook": "Facebook",
    "login": "Iniciar sesión como proveedor",
    "signup": "Registrarse como proveedor",
    "signup-now": "Regístrate ahora",
    "Link_to_book": "Enlace para reservar citas",
    "logout": "Cerrar sesión",
    "schedule": "Agenda",
    "create_appointment": "Crear cita",
    "dateAndTime": "Fecha y hora",
    "customerName": "Nombre del cliente",
    "customerPhone": "Teléfono del cliente",
    "customerLocation": "Dirección del cliente",
    "create": "Crear",
    "cancel": "Cancelar",
    "activity": "Servicio",
    "appointment_scheduled": "Cita programada con éxito",
    "book_appointment": "Reservar cita",
    "business_days_explanation": "Por favor marca tus horas de trabajo semanales",
    "personal_details_explanation": "Por favor verifica tu número de teléfono y completa los campos restantes",
    "profession_explanation": "Por favor selecciona una profesión de la lista, si no está en la lista, selecciona 'Agregar' y luego los tipos de tratamientos, duración y precios",
    "link_copied_to_clipboard": "Enlace copiado al portapapeles",
    "no_reviews": "Aún no hay reseñas",
    "press_available_date": "Para programar una cita, haz clic en una fecha disponible",
    "app_name": "Agendia",
    "user_exist": "El usuario ya está registrado en el sistema, por favor inicia sesión",
    "get_notifications_on_this_device": "Recibir notificaciones de citas en este dispositivo",
    "cant_subscribe_to_notifications": "No pudimos agregar el dispositivo para recibir notificaciones",
    "device_added_successfully": "El dispositivo recibirá notificaciones cuando se programe una cita",
    "cancel-meeting": "Cancelar cita",
    "doesnt-matter": "No importa",
    "cancel-appointment": "Cancelar cita",
    "are-you-sure-cancel-appointment": "¿Estás seguro de que deseas cancelar la cita?",
    "appointment_deleted": "Cita cancelada con éxito",
    "edit_appointment": "Editar cita",
    "update": "Actualizar",
    "appointment_updated": "Cita actualizada",
    "edit_details": "Editar detalles",
    "address": "Dirección de consulta",
    "more_info": "Más información",
    "updated_successfully": "Detalles actualizados con éxito",
    "sunday": "Domingo",
    "monday": "Lunes",
    "tuesday": "Martes",
    "wednesday": "Miércoles",
    "thursday": "Jueves",
    "friday": "Viernes",
    "saturday": "Sábado",
    "end_time": "Hora de finalización",
    "start_time": "Hora de inicio",
    "add": "Agregar",
    "send-code": "Enviar código de verificación",
    "sign-up-with-google": "Google",
    "sign-up-with-facebook": "Facebook",
    "type-phone-number": "Por favor ingresa tu número de teléfono",
    "enter-code": "Por favor ingresa el código recibido",
    "confirm": "Confirmar",
    "wrong-code": "El código ingresado es incorrecto",
    "phone-wrong": "El número de teléfono ingresado no es válido",
    "verify-phone-number": "Verificar número de teléfono",
    "cant-logout": "No se puede cerrar sesión",
    "drag_image_or_click": "Agregar imágenes",
    "could-not-upload": "Error al subir la imagen",
    "could-not-delete": "Error al eliminar la imagen",
    "max-file-exceeded": "Has excedido el número máximo de imágenes permitidas",
    "in-address": "En la dirección",
    "booking-system": "Agendia - Reserva citas fácilmente",
    "app-descp": "Reserva citas con miles de profesionales con un solo clic, según reseñas, tipo de tratamiento y disponibilidad",
    "booking-system-supplier": "Sistema de reservas para profesionales",
    "app-descp-supplier": "Déjanos encontrar clientes para ti. Nosotros nos encargamos del resto",
    "pay": "Pagar",
    "month": "Mes",
    "3months": "3 meses",
    "6months": "6 meses",
    "days-left": "Días restantes de uso del sistema",
    "add-more-days": "Agregar más días",
    "no-options": "Sin opciones",
    "is_receive_clients": "¿Recibes clientes en casa/clínica?",
    "which_cities_reach": "¿Vas a domicilio? Marca la zona de servicio",
    "cities": "Ciudades",
    "allow-payments": "Aceptar pagos al momento de la reserva",
    "meshulam-not-connected": "Configuración de pagos aún no conectada",
    "meshulam-connected": "Configuración de pagos correcta",
    "general-error": "Ha ocurrido un error, por favor contacta con soporte",
    "meshulam-signup-explanation": "Después del registro, recibirás un enlace en tu teléfono y correo electrónico para registrarte en los servicios de pago de Meshulam. Cuando tu cuenta sea aprobada por Meshulam, podrás recibir pagos en Agendia fácilmente",
    "meshulam-signup-explanation-update": "Después de actualizar los detalles, recibirás un enlace en tu teléfono y correo electrónico para registrarte en los servicios de pago de Meshulam. Cuando tu cuenta sea aprobada por Meshulam, podrás recibir pagos en Agendia fácilmente",
    "too-many-attemps": "Demasiados intentos de inicio de sesión, por favor intenta más tarde",
    "edit_profile": "Editar perfil",
    "show_page": "Ver página",
    "share_page": "Compartir página",
    "edit-picture": "Editar imagen",
    "i-finished": "He terminado",
    "code-sent-to-number": "Código secreto enviado al número: ",
    "sign-up": "Inscribirse",
    "error_registering_supplier": "Ha ocurrido un error al registrar el proveedor, por favor contacta con soporte",
    "sign-up-as-supplier": "Inscribirse como proveedor",
    "terms_and_conditions": "Términos y condiciones",
    "privacy_policy": "Política de privacidad",
    "contact_us": "Contáctanos",
    "all_rights_reserved": "Todos los derechos reservados",
    "terms_section_1_title": "1. Aceptación de los Términos",
    "terms_section_1_content": "Al acceder y utilizar nuestra plataforma, usted acepta estar sujeto a estos términos y condiciones. Si no está de acuerdo con alguna parte de estos términos, no podrá acceder a nuestros servicios.",
    
    "terms_section_2_title": "2. Uso del Servicio",
    "terms_section_2_content": "Nuestra plataforma está diseñada para facilitar la reserva de citas entre proveedores de servicios y clientes. Usted acepta utilizar el servicio solo para fines legales y de acuerdo con estos términos.",
    
    "terms_section_3_title": "3. Cuentas de Usuario",
    "terms_section_3_content": "Al crear una cuenta, usted es responsable de mantener la confidencialidad de su información de inicio de sesión y de todas las servicios que ocurran bajo su cuenta.",
    
    "terms_section_4_title": "4. Cancelaciones y Reembolsos",
    "terms_section_4_content": "Las políticas de cancelación y reembolso están sujetas a los términos específicos de cada proveedor de servicios. Por favor, revise las políticas individuales antes de realizar una reserva.",
    
    "terms_section_5_title": "5. Modificaciones",
    "terms_section_5_content": "Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en la plataforma.",

    "privacy_section_1_title": "1. Información que Recopilamos",
    "privacy_section_1_content": "Recopilamos información que usted nos proporciona directamente, como su nombre, dirección de correo electrónico, número de teléfono y detalles de pago cuando utiliza nuestros servicios.",
    
    "privacy_section_2_title": "2. Uso de la Información",
    "privacy_section_2_content": "Utilizamos su información para proporcionar, mantener y mejorar nuestros servicios, procesar transacciones y comunicarnos con usted sobre su cuenta o nuestros servicios.",
    
    "privacy_section_3_title": "3. Compartir Información",
    "privacy_section_3_content": "No compartimos su información personal con terceros excepto cuando es necesario para proporcionar nuestros servicios o cuando la ley lo requiere.",
    
    "privacy_section_4_title": "4. Seguridad de los Datos",
    "privacy_section_4_content": "Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra el acceso no autorizado o la divulgación.",
    
    "privacy_section_5_title": "5. Sus Derechos",
    "privacy_section_5_content": "Usted tiene derecho a acceder, corregir o eliminar su información personal. También puede optar por no recibir comunicaciones de marketing en cualquier momento.",
    "subject": "Asunto",
    "message": "Mensaje",
    "send_message": "Enviar mensaje",
    "contact_info": "Información de contacto",
    "company_address": "Querétaro, Mexico",
    "contact_form_success": "¡Gracias por tu mensaje! Nos pondremos en contacto contigo pronto.",
    "user_doesnt_exist": "El usuario no existe, por favor regístrate",
    "by_signing_up": "Al registrarte, aceptas nuestros",
    "and": "y",
    "homepage": "Página principal",
    "short_hash_field": "URL de la página de reservas",
    "short_hash_exist": "Esta URL ya está en uso.",
    "select_activity": "Seleccionar servicio",
    "available_hours": "Horas disponibles",
    "there_are_no_appointments_this_date": "No hay citas disponibles para esta fecha.",
    "thankyou_loading": "Procesando tu reserva...",
    "thankyou_success_title": "¡Reserva Confirmada!",
    "thankyou_details_title": "Detalles de la Cita",
    "thankyou_details_service": "Servicio",
    "thankyou_details_date": "Fecha",
    "thankyou_details_time": "Hora",
    "thankyou_details_duration": "Duración",
    "thankyou_details_minutes": "minutos",
    "thankyou_details_location": "Ubicación",
    "thankyou_calendar_description": "Cita para {{service}}",
    "thankyou_calendar_google": "Añadir a Google Calendar",
    "thankyou_calendar_apple": "Añadir a Apple Calendar",
"service_at_home":"Servicio a domicilio",
"service_at_clinic":"Servicio en clinica",
"supplier_doesnt_reach_location":"El proveedor no llega a esta ubicación.",
"direction":"Dirección",
"driving_time":"Tiempo de conducción",
"center_polygon":"Modifica la zona de servicio al centro del mapa.",
"allow_multiple_services":"Permitir agendar múltiples servicios en una misma cita",
"short_hash_invalid":"El enlace solo puede contener caracteres en minúsculas, números y guiones medios.",
}

export default es